"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mutateUpdateVacationFunds = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const updateVacationFundsMutation = (0, graphql_tag_1.default) `
  mutation UpdateVacationFunds(
    $workspaceId: ID!
    $userId: ID!
    $data: RoleInputData
  ) {
    roleUpdate(workspace: $workspaceId, user: $userId, data: $data) {
      vacation {
        unit
        contractType
        amount
      }
    }
  }
`;
const mutateUpdateVacationFunds = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(updateVacationFundsMutation, {
        variables: {
            workspaceId: variables.workspaceId,
            userId: variables.userId,
            data: {
                vacation: variables.data,
            },
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.roleUpdate?.vacation;
};
exports.mutateUpdateVacationFunds = mutateUpdateVacationFunds;
